<template>
<div :id="componentId">
  <div class="toolbar mb8">
    <select class="custom-select ib" v-model="selectedUsername"
        @change="onChangeUsername">
      <option value="">user: 全て</option>
      <option v-for="e in usernames" :value="e.key" :key="e.key">
        {{e.val}}
      </option>
    </select>
    <sort-button class="ib sort-bt1 ml4" @sort="onDtSort"
        :toggle-type="sort.dt.toggleType">
      登録日
    </sort-button>
  </div>
  <div :id="listWrapId" class="list-wrap">
    <b-list-group class="selectable">
      <b-list-group-item v-for="e in displayedPoles" :key="e.id"
        :id="listItemId(e)"
        :class="getListItemClz(e)"
        @click="onListItemClick(e)"
        v-html="itemDisp(e)">
      </b-list-group-item>
    </b-list-group>
  </div>
  <pager class="mt8"
    :item-count="itemCount"
    :items-per-page="itemsPerPage"
    :page-range="1"
    :margin-pages="0"
    :force-page="currentPage - 1"
    @click="onChangePage"
  ></pager>
</div>
</template>

<script>
import Vue from 'vue'
import sortMixin from '@/mixin/sortMixin'
import * as eventNames from '@/consts/eventNames'
import * as sortStates from '@/consts/sortStates'

const dtFormatUTC = Vue.filter('dtFormatUTC')

export default {
  name: 'pole-list',
  props: {
    src: {
      type: Array,
      default() {
        return []
      }
    },
    dispType: {
      type: String,
      default: 'full',
    },
    stream: {
      type: Object,
    }
  },
  data() {
    return {
      isReady: false,

      filteredPoles: [],
      displayedPoles: [],
      allPoles: [],
      polesByUsername: {},
      selectedPolesMap: {},

      usernames: [],
      selectedUsername: '',

      sort: {
        dt: {
          toggleType: sortStates.TOGGLE_TYPE_AD,
          state: sortStates.SORT_STATE_ASC,
        }
      },

      onResizeFunc: null,

      itemsPerPage: 2000,
      currentPage: 1,
    }
  },
  computed: {
    componentId() {
      return `pole-list-${this._uid}`
    },
    listWrapId() {
      return `list-wrap-${this._uid}`
    },
    itemCount() {
      return this.filteredPoles.length
    },
  },
  watch: {
    src() {
      const { poles, polesByUsername, usernames } =
        this.convPoles(this.src.slice())
      this.allPoles = poles
      this.polesByUsername = polesByUsername
      this.usernames = usernames
      this.selectedUsername = ''
      this.isReady = true
      this.onChangeUsername()
    }
  },
  mounted() {
    this.onResizeFunc = () => {
      const h = window.innerHeight - 170
      const elem = document.getElementById(this.listWrapId)
      elem.style.height = `${h}px`
    }
    this.onResizeFunc()
    window.addEventListener('resize', this.onResizeFunc)
    this.setListeners()
  },
  destroyed() {
    window.removeEventListener('resize', this.onResizeFunc)
  },
  mixins: [sortMixin],
  methods: {
    listItemId(e) {
      return `list-item-${e.id}-${this._uid}`
    },
    getListItemClz(e) {
      // order matters
      const arr = []
      if (e.pole_number) {
        arr.push('attached')
      }
      if (this.selectedPolesMap[e.id]) {
        arr.push('selected')
      }
      return arr.join(' ')
    },
    setListeners() {
      this.stream.recv(eventNames.SELECT_POLES,
        ({ ids }) => {
          if (!this.isReady) { return }
          if (!ids || ids.length === 0) { return }
          const obj = ids.reduce((acc, id) => {
            acc[id] = true; return acc
          }, {})
          this.selectedPolesMap = obj
          this.scrollToItemById(ids[0])
        }
      )
      this.stream.recv(eventNames.UNSELECT_POLES,
        ({ ids }) => {
          if (!this.isReady) { return }
          if (!ids || ids.length === 0) { return }
          ids.forEach(id => {
            Vue.delete(this.selectedPolesMap, id)
          })
        }
      )
      this.stream.recv(eventNames.UPDATED_POLES,
        ({ poles }) => {
          if (!poles || poles.length === 0) { return }
          // update完了後は選択を解除したい
          poles.forEach(pole => {
            Vue.delete(this.selectedPolesMap, pole.id)
            this.stream.send(eventNames.UNSELECT_POLES,
              { ids: [pole.id] })
          })
        }
      )
    },
    scrollToItemById(id) {
      window.scrollManager.scrollTo(
        '#' + this.listItemId({ id }),
        200,
        {
          offset: -10,
          container: '#' + this.listWrapId,
        }
      )
    },
    itemDisp(e) {
      if (this.dispType === 'full') {
        return this.fullItemDisp(e)
      } else {
        return 'Wrong disp type'
      }
    },
    fullItemDisp(e) {
      return `
        <div class="item-disp">
          <p class="item-disp-row row1">
            【${e.pole_number ? '登録済' : '未登録'}】user: ${e.username}
          </p>
          <p class="item-disp-row row2">
            登録日: ${dtFormatUTC(e.created_at, 'yyyy-mm-dd HH:MM:SS')}
            <br>
            更新日: ${dtFormatUTC(e.updated_at, 'yyyy-mm-dd HH:MM:SS')}
          </p>
          <p class="item-disp-row row3">
            備考: ${e.bikou1 || 'なし'}
          </p>
        </div>
      `
    },
    convPoles(arr) {
      arr.sort((a, b) => {
        let v1 = new Date(a.created_at)
        let v2 = new Date(b.created_at)
        if (v1 < v2) {
          return -1
        } else if (v1 > v2) {
          return 1
        } else {
          v1 = new Date(a.updated_at)
          v2 = new Date(b.updated_at)
          return v1 < v2 ? -1 : (v1 > v2 ? 1 : 0)
        }
      })
      const poles = arr
      const polesByUsername = {}
      const usernameObj = {}
      for (const e of arr) {
        usernameObj[e.username] = 1

        if (!polesByUsername[e.username]) {
          polesByUsername[e.username] = []
        }
        polesByUsername[e.username].push(e)
      }

      const usernames = Object.keys(usernameObj).sort().map(e => {
        return {
          key: e,
          val: 'user: ' + e,
        }
      })

      return { poles, polesByUsername, usernames }
    },
    onChangeUsername() {
      this.currentPage = 1
      this.updateFilteredPoles()
      const elem = document.getElementById(this.listWrapId)
      elem.scroll(0, 0)
    },
    onChangePage(page) {
      this.currentPage = page
      this.setDisplayedPoles()
      const elem = document.getElementById(this.listWrapId)
      elem.scroll(0, 0)
    },
    updateFilteredPoles() {
      let poles = []
      if (!this.selectedUsername) {
        poles = this.allPoles
      } else {
        poles = this.polesByUsername[this.selectedUsername]
      }
      this.filteredPoles = this.sortedArrayBy(poles,
        { prop: 'created_at', sortState: this.sort.dt.state })
      this.setDisplayedPoles()
    },
    setDisplayedPoles() {
      const startIdx = this.itemsPerPage * Math.max(this.currentPage - 1, 0)
      this.displayedPoles = this.filteredPoles.slice(
        startIdx, startIdx + this.itemsPerPage)
      this.stream.send(eventNames.CHANGE_POLES,
        { poles: this.displayedPoles })
    },
    onListItemClick(e) {
      if (this.selectedPolesMap[e.id]) {
        // deselect
        Vue.delete(this.selectedPolesMap, e.id)
        this.stream.send(eventNames.UNSELECT_POLES, { ids: [e.id] })
        return
      }

      this.selectedPolesMap = { [e.id]: e }
      this.stream.send(eventNames.SELECT_POLES, { ids: [e.id] })
    },
    onDtSort({ sortState }) {
      this.sort.dt.state = sortState
      this.updateFilteredPoles()
    },
  }
}
</script>

<style lang="scss" scoped>
.custom-select {
  width: 70%;
}
.sort-bt1 {
  width: 27%;
}
</style>
